import { render } from "./ImageTrioEditModal.vue?vue&type=template&id=5a41b5be&scoped=true"
import script from "./ImageTrioEditModal.vue?vue&type=script&lang=js"
export * from "./ImageTrioEditModal.vue?vue&type=script&lang=js"

import "./ImageTrioEditModal.vue?vue&type=style&index=0&id=5a41b5be&scoped=true&lang=less"
import "./ImageTrioEditModal.vue?vue&type=style&index=1&id=5a41b5be&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a41b5be"]])

export default __exports__